import styled from "styled-components";
import {Text} from "./Shared";
import {solease_light_gray} from "../../constants/Colors";
import {useState} from "react";

const TooltipWrapper = styled.div`
  display: flex;
  align-items: center;
  margin: 10px 0;
  cursor: pointer;
  
  ${Text}{
    margin: 0;
    margin-left: 5px;
    color: ${solease_light_gray};
  }
`

const questionMark = require('../../assets/icons/questionMark.svg').default

const Tooltip = ({text, description}: { text: string, description: string }) => {
    const [expanded, setExpanded] = useState(false)

    return (
        <>
        <TooltipWrapper onClick={()=>setExpanded(!expanded)}>
            <img src={questionMark} alt=''/>
            <Text small>{text}</Text>
        </TooltipWrapper>
            {
                expanded &&
                <Text style={{color: solease_light_gray}} small>{description}</Text>
            }
        </>
    )
}

export default Tooltip
